import { render, staticRenderFns } from "./NewCampaignSms.vue?vue&type=template&id=54ffd7aa&scoped=true&"
import script from "./NewCampaignSms.vue?vue&type=script&lang=js&"
export * from "./NewCampaignSms.vue?vue&type=script&lang=js&"
import style0 from "./NewCampaignSms.vue?vue&type=style&index=0&id=54ffd7aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ffd7aa",
  null
  
)

export default component.exports